export default "__VITE_ASSET__DQHMGffe__"